import { Chart, type ChartConfiguration } from 'chart.js';

export const BaseChartConfig: ChartConfiguration = {
    type: 'bar',
    data: {
        labels: [],
        datasets: [],
    },
    options: {
        aspectRatio: 2, // This is required for the chart to be _actually_ responsive
        plugins: {
            tooltip: {
                enabled: true,
                callbacks: {
                    // Prefix dollar value of hover pop-up with dollar sign
                    label: (context) => `$${context.formattedValue}`,
                },
            },
            legend: {
                position: 'bottom',
                labels: {
                    color: '#292f30',
                    font: {
                        size: 15,
                    },

                    // These configs make the legend color squares smaller
                    boxWidth: 17, // Set width of color squares
                    usePointStyle: true, // Makes them circular, required for custom height
                    pointStyle: 'rect', // Ensures they stay rectangular
                    padding: 45, // Adds space between labels

                    generateLabels: function addBordersToLegendLabelSquares(
                        chart
                    ) {
                        const original =
                            Chart.defaults.plugins.legend.labels.generateLabels;
                        const borderColor = ['#0F5A89', '#F29970', '#84C400'];

                        return original(chart).map((label, index) => ({
                            ...label,
                            strokeStyle: borderColor[index], // border color
                            lineWidth: 1, // border thickness
                        }));
                    },
                },
            },
        },
        layout: {
            padding: 48,
        },
        scales: {
            x: {
                ticks: {
                    color: '#292f30',
                    font: {
                        size: 16,
                    },
                },
                grid: {
                    display: false, // Remove vertical grid lines
                },
            },
            y: {
                min: 0,
                max: 200000,
                ticks: {
                    stepSize: 50000,
                    callback: (value) => `$${value.toLocaleString()}`, // Format Y-axis labels with $ prefix and commas
                    color: '#292f30',
                    font: {
                        size: 16,
                    },
                },
                grid: {
                    color: '#415061', // Set grid line color
                    lineWidth: ({ tick }) => (tick.value === 0 ? 2 : 1), // This makes the $0 line thicker (as per the design)
                },
            },
        },
    },
};
